import {
  SchoolPeriodUser,
  type SchoolPeriodUserInput
} from '@/core/domain/school/user/SchoolPeriodUser'
import SchoolPeriodUserMapper from '@/core/infrastructure/mappers/school/period/SchoolPeriodUserMapper.ts'
import type ISchoolPeriodUserRepository from '@/core/domain/school/user/ISchoolPeriodUserRepository.ts'

export default class PrepareSchoolPeriodUserEditUseCase {
  private readonly schoolPeriodUsersRepository: ISchoolPeriodUserRepository

  constructor(schoolPeriodUsersRepository: ISchoolPeriodUserRepository) {
    this.schoolPeriodUsersRepository = schoolPeriodUsersRepository
  }

  /**
   * Prépare les données pour le formulaire d'édition d'un utilisateur
   */
  async execute(
    schoolId: number,
    schoolPeriodId: number,
    schoolPeriodUser: SchoolPeriodUser
  ): Promise<SchoolPeriodUserInput> {
    // Récupérer les détails complémentaires de l'utilisateur
    const user = await this.schoolPeriodUsersRepository.fetchSchoolPeriodUserByIdentifier(
      schoolId,
      schoolPeriodId,
      schoolPeriodUser.userIdentifier
    )

    // Construire l'objet d'entrée pour le formulaire
    return SchoolPeriodUserMapper.toInput(schoolPeriodUser, user, schoolPeriodId)
  }
}
